import { useState, useEffect } from 'react';
import axios from 'axios';

const useShopifyProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://lunabackend.netlify.app/.netlify/functions/server/products');
        setProducts(response.data);
      } catch (error) {
        console.error('API Request Error:', error);
        // Gérer les erreurs de requête
      }
    };

    fetchProducts();
  }, []);

  return products;
};

export default useShopifyProducts;
